import { useEffect, useRef } from "react";
import { API_BASE_URL } from "../env";

const HEARTBEAT_INTERVAL = 15_000; // 15s

/**
 * Sends periodic heartbeats to the backend so admins can see
 * anonymous visitors on public pages (login, signup, etc.).
 */
export function useVisitorHeartbeat(page: string) {
    const pageRef = useRef(page);
    pageRef.current = page;

    useEffect(() => {
        const send = () => {
            fetch(`${API_BASE_URL}/public/heartbeat`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ page: pageRef.current }),
            }).catch(() => {});
        };

        send();
        const id = setInterval(send, HEARTBEAT_INTERVAL);
        return () => clearInterval(id);
    }, []);
}
